import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './styles/optimized-performance.css'

createRoot(document.getElementById("root")!).render(<App />);

// Polyfill for requestIdleCallback
if (typeof window !== 'undefined' && !('requestIdleCallback' in window)) {
  (window as any).requestIdleCallback = (cb: Function) => setTimeout(cb, 1);
}

// Defer animation optimizer to after user interaction
if (typeof window !== 'undefined') {
  const loadOptimizer = () => {
    requestIdleCallback(() => {
      import('./utils/animationOptimizer').then(({ setupAnimationOptimizer }) => {
        setupAnimationOptimizer();
      });
    }, { timeout: 3000 });
  };
  
  // Load on first scroll or after 5 seconds
  const onScroll = () => {
    loadOptimizer();
    window.removeEventListener('scroll', onScroll);
  };
  window.addEventListener('scroll', onScroll, { passive: true, once: true });
  setTimeout(loadOptimizer, 5000);
}
